// extracted by mini-css-extract-plugin
export default {"wrapper":"ZM-z","ratingContainer":"_M-z","ratingValue":"aN-z","starSprite":"bN-z","ratingLabel":"cN-z","error":"dN-z","errorBox":"eN-z"};